import _ from 'underscore';

const ExpectedErrorStrings = [
  'TypeError: Failed to fetch',
  'TypeError: Load failed',
  'TypeError: NetworkError when attempting to fetch resource',
  '{"readyState":0,"status":0,"statusText":"error","headers":{}}',
].map(errorString => errorString.toLowerCase());

export function isExpectedErrorString(error) {
  if (!error) {
    return false;
  }

  const errorMessage = _.isError(error) ? error : JSON.stringify(error);
  const errorMessageInLowerCase = _.isFunction(_.get(errorMessage, 'toLowerCase')) ? errorMessage.toLowerCase() : '';
  return _.some(
    ExpectedErrorStrings,
    errorString => errorMessageInLowerCase.indexOf(errorString) > -1
  );
}
